<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->
<div class="mt-2">
  <div class="creditCardsRow">
    <div *ngFor="let card of merchant.acceptedCreditCards">
      <img
        [src]="'/assets/img/cards/' + card.toLowerCase() + '.png'"
        alt="{{ CREDIT_CARDS[card].title }}"
        title="{{ CREDIT_CARDS[card].title }}"
      />
    </div>
  </div>
</div>
